<template>
  <div class="slip-page">
    <h3 class="page-title">{{ $t("voucher.vouchers") }}</h3>

    <div class="type-tabs">
      <button
        type="button"
        class="type-chip"
        :class="{ active: type === 'twod' }"
        @click="changeType('twod'), fetchHistory()"
      >
        {{ $t("2d") }}
      </button>
      <button
        type="button"
        class="type-chip"
        :class="{ active: type === 'threed' }"
        @click="changeType('threed'), fetchHistory()"
      >
        {{ $t("3d") }}
      </button>
      <button
        type="button"
        class="type-chip"
        :class="{ active: type === 'maung' }"
        @click="changeType('maung'), fetchHistory()"
      >
        {{ $store.state.language === "mm" ? "မောင်း" : "Maung" }}
      </button>
      <button
        type="button"
        class="type-chip"
        :class="{ active: type === 'body' }"
        @click="changeType('body'), fetchHistory()"
      >
        {{ $store.state.language === "mm" ? "ဘော်ဒီ" : "Body" }}
      </button>
    </div>

    <section class="filter-card">
      <div class="filter-row">
        <div class="select-wrap" v-if="type === 'twod'">
          <TwoDSelect type="draw" :data="params" field="draw" />
        </div>
        <div class="select-wrap" v-if="type !== 'threed'">
          <v-select
            v-model="params.date"
            :reduce="(draw) => draw.data"
            label="label"
            :options="dateOptions"
          ></v-select>
        </div>
        <div class="select-wrap" v-if="type === 'threed'">
          <v-select
            v-model="params.date"
            :reduce="(draw) => draw.data"
            label="label"
            :options="dateOptionsThreed"
          ></v-select>
        </div>
        <button type="button" class="search-btn" @click="fetchHistory">
          {{ $t("voucher.search") }}
        </button>
      </div>
      <label
        class="bingo-check"
        v-if="type === 'twod' || type === 'threed'"
      >
        <b-form-checkbox
          size="lg"
          v-model="isBingo"
          v-on:change="fetchHistory()"
        ></b-form-checkbox>
        <span>{{ $t("voucher.search") }}</span>
      </label>
    </section>

    <section class="list-card">
      <div class="loading-wrap" v-if="isSearch">
        <Loading color="#e7b534" size="24" class="px-4 py-0" />
        <span>{{ $t("please_wait") }}</span>
      </div>

      <div class="table-responsive" v-if="!isSearch">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th>
                <div class="d-flex">
                  <div class="mx-auto">
                    {{ $t("voucher.voucher_id") }}
                  </div>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <div class="mx-auto">
                    {{ $t("voucher.remark") }}
                  </div>
                </div>
              </th>
              <th v-if="isBingo">
                <div class="d-flex">
                  <div class="mx-auto">
                    {{ $t("voucher.bingo_amount") }}
                  </div>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <div class="mx-auto">
                    {{ $t("voucher.total_amount") }}
                  </div>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <div class="mx-auto">
                    {{ $t("voucher.bet_date") }}
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(history, index) in betHistory"
              :key="index"
              @click="getSlipdata(history)"
              class="betsliptable-row"
            >
              <th scope="row">
                <div class="media d-flex">
                  <span class="mx-auto mb-0 text-md">{{
                    history.voucher_id
                  }}</span>
                </div>
              </th>
              <th scope="row">
                <div class="media d-flex">
                  <span
                    class="mx-auto mb-0 badge badge-danger"
                    v-if="!history.isBet"
                  >
                    Incomplete
                  </span>
                  <span
                    class="mx-auto mb-0 text-md"
                    v-if="
                      history.isBet &&
                      (history.bingo_amount > 0 || history.is_bingo)
                    "
                  >
                    <i class="fas fa-check text-success pr-0"></i>
                  </span>
                  <span
                    class="mx-auto mb-0 text-md"
                    v-if="history.isBet && !history.is_bingo"
                  >
                    <i class="fas fa-times text-danger"></i>
                  </span>
                </div>
              </th>
              <th scope="row" v-if="isBingo">
                <div class="media d-flex">
                  <span class="mx-auto mb-0 text-md">{{
                    history.bingo_amount
                  }}</span>
                </div>
              </th>
              <th scope="row">
                <div class="media d-flex">
                  <span class="mx-auto mb-0 text-md amount-cell">{{
                    history.total_amount
                  }}</span>
                </div>
              </th>
              <th scope="row">
                <div class="media d-flex">
                  <span class="mx-auto mb-0 text-md date-cell">{{
                    betDate(history.created_at)
                  }}</span>
                </div>
              </th>
            </tr>
            <tr class="total-row">
              <th scope="row"></th>
              <th scope="row"></th>
              <th scope="row" v-if="isBingo">
                <div class="media d-flex">
                  <span class="mx-auto mb-0 text-md"
                    >{{ $t("voucher.total") }} -
                    <b class="bingo-total">{{
                      Number(totalBingoAmount()).toLocaleString()
                    }}</b></span
                  >
                </div>
              </th>
              <th scope="row">
                <div class="media d-flex">
                  <span class="mx-auto mb-0 text-md"
                    >{{ $t("voucher.total") }} -
                    <b class="gold-total">{{
                      Number(totalVoucherAmount()).toLocaleString()
                    }}</b></span
                  >
                </div>
              </th>
              <th></th>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

      <!-- === Voucher History === -->
      <div class="col-4" ref="captureElement">
        <div
          class="modal fade"
          id="voucher-history"
          tabindex="-1"
          role="dialog"
          aria-labelledby="modal-form"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal- modal-dialog-centered"
            role="document"
          >
            <div class="modal-content">
              <div class="text-center modal-cross" @click="closeModal">X</div>
              <button
                class="capture-btn"
                type="button"
                @click="captureThisVoucher()"
              >
                <i class="fas fa-camera"></i>
              </button>
              <div
                class="modal-body p-0"
                id="capture"
                v-if="
                  type === 'maung' ||
                  type === 'body' ||
                  type === '1x2' ||
                  type === 'correctScore'
                "
              >
                <FBVoucher
                  :type="type"
                  :datas="datas"
                  :slipId="slipId"
                  :currentTime="bet_date"
                  :isHistory="true"
                  :is_result="is_result"
                  :bingo_amount="bingo_amount"
                />
              </div>
              <div class="modal-body p-0" id="capture" v-else>
                <Voucher
                  type="history"
                  :datas="datas"
                  :slipId="slipId"
                  :currentTime="bet_date"
                  :isTwod="isTwod"
                  :name="name"
                  :remark="remark"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
// import SideNav from './components/SideNav.vue';
import Voucher from "./components/Voucher.vue";
import { DateTime } from "luxon";
import { Loading, Dialog } from "vant";
import FBVoucher from "./components/FBVoucher.vue";
import html2canvas from "html2canvas";
import { mapActions } from "vuex";
import TwoDSelect from "./components/TwoDSelect.vue";

export default {
  components: {
    TwoDSelect,
    // SideNav,
    Voucher,
    Loading,
    FBVoucher,
  },
  data() {
    return {
      isSearch: false,
      isBingo: false,
      type: "twod",
      remark: "",
      name: "",
      searchKeyword: "",
      params: {
        draw: "",
        date: "",
      },
      dateOptionsThreed: [
        {
          label: null,
          data: null,
        },
        {
          label: null,
          data: null,
        },
      ],
      dateOptions: [],
      betHistory: {},
      datas: [],
      slipId: null,
      bet_date: null,
      isTwod: true,
      bingo_amount: null,
      is_result: false,
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    async captureThisVoucher() {
      Dialog.confirm({
        title:
          this.$store.state.language === "en"
            ? "Are you sure to take screenshot?"
            : "ဓာတ်ပုံအနေဖြင့် သိမ်းမှာ သေချာပါသလား?",
        cancelButtonText:
          this.$store.state.language === "en" ? "Cancel" : "မသိမ်းတော့ပါ",
        confirmButtonText:
          this.$store.state.language === "en" ? "Sure" : "သေချာပြီ",
      })
        .then(async () => {
          await this.captureElement();
          Toast.success(
            this.$store.state.language === "en" ? "DONE!" : "ပြီးပြီ"
          );
        })
        .catch(() => {});
    },
    async captureElement() {
      try {
        // Ensure the element exists before capturing it
        const element = document.getElementById("capture");
        if (!element) {
          console.error("Element not found");
          return;
        }

        const canvas = await html2canvas(element);
        const imgData = canvas.toDataURL("image/png");

        // Create a link element for downloading the captured image
        const link = document.createElement("a");
        link.href = imgData;
        link.download = "screenshot.png";
        link.click();
      } catch (error) {
        console.error("Error capturing element:", error);
      }
    },
    totalVoucherAmount() {
      let total = 0;
      for (let i = 0; i < this.betHistory.length; i += 1) {
        total += parseInt(this.betHistory[i].total_amount, 10);
      }
      return total;
    },
    totalBingoAmount() {
      let total = 0;
      for (let i = 0; i < this.betHistory.length; i += 1) {
        total += parseInt(this.betHistory[i].bingo_amount, 10);
      }
      return total;
    },
    setLastHalfMonth() {
      this.dateOptionsThreed[0].label = "Current Draw";
      this.dateOptionsThreed[0].data = "current";

      this.dateOptionsThreed[1].label = "Last Draw";
      this.dateOptionsThreed[1].data = "last";

      this.params.date = "current";
    },
    changeType(type) {
      if (type === "threed") {
        this.setLastHalfMonth();
      } else {
        this.params.date = moment(new Date()).format("l");
        this.params.draw = this.currentDraw();
      }
      this.type = type;
    },
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format("l");
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    async getSlipdata(data) {
      try {
        if (
          this.type !== "maung" &&
          this.type !== "body" &&
          this.type !== "1x2" &&
          this.type !== "correctScore"
        ) {
          const res = await axios.post(
            "vouchers/datas",
            {
              voucher_id: data.id,
              type: data.type,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          this.isTwod = data.type === "twod";
          this.slipId = data.id;
          this.name = data.name;
          this.remark = data.remark;
          this.bet_date =
            data.type === "twod"
              ? this.betTime(data.created_at)
              : this.betTime(data.created_at);
          this.datas = res.data.data;
          $("#voucher-history").modal("show");
        } else {
          this.datas = data.team_vouchers;
          this.bingo_amount = data.bingo_amount;
          this.slipId = data.id;
          this.is_result = data.isBet;
          this.type = data.type;
          this.bet_date = this.betTime(data.created_at);
          $("#voucher-history").modal("show");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchHistory() {
      try {
        this.isSearch = true;
        let res;
        if (this.type === "twod" || this.type === "threed") {
          res = await axios.post(
            "/vouchers/datas/all",
            {
              draw: this.params.draw,
              date: this.params.date,
              search: this.searchKeyword,
              isBingo: this.isBingo,
              type: this.type,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
        } else {
          res = await axios.post(
            "/fb-vouchers-history",
            {
              draw_date: this.params.date,
              type: this.type,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
        }

        this.betHistory = res.data.data;
        this.rows = res.data.total;
        this.isSearch = false;
      } catch (error) {
        console.log(error);
      }
    },
    betDate(time) {
      return moment(time).format("l");
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString(
        "en-US",
        { timeZone: targetTimeZone }
      );
      return moment(adjustedDrawDate).format("lll");
    },
    closeModal() {
      $("#voucher-history").modal("hide");
    },
    currentDraw() {
      const currentHour = new Date().getHours();
      if (currentHour < 12) {
        return "12:00";
      }
      return "4:30";
    },
  },
  //   computed: {

  //   },
  watch: {
    searchKeyword() {
      if (this.searchKeyword === "") {
        this.fetchHistory();
      }
    },
    currentPage() {
      this.fetchHistory();
    },
    // datas() {
    //   $('#voucher-history').modal('show');
    // },
    type() {
      if (this.type !== "threed") {
        this.params.date = moment(new Date()).format("l");
        this.params.draw = this.currentDraw();
      } else {
        this.setLastHalfMonth();
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      //   this.$router.push("/auth/login");
    }
    // if (authUser && !authUser.is_verified) {
    //   this.$router.push('/auth/verify');
    // }
    this.params.date = moment(new Date()).format("l");
    this.params.draw = this.currentDraw();
    this.fetchHistory();
    this.setOneMonth();
  },
};
</script>
<style scoped>
.slip-page {
  min-height: 100vh;
  padding: 14px 14px 8rem;
}
.page-title {
  margin-bottom: 12px;
  color: #f0e6c8;
  font-weight: 700;
}
.type-tabs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin-bottom: 12px;
}
.type-chip {
  flex: 1;
  min-width: 0;
  height: 2.4rem;
  border: 0;
  border-radius: 10px;
  background: #2a2a2a;
  color: #f0e6c8;
  font-size: 0.82rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}
.type-chip.active {
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
}
.filter-card,
.list-card {
  background: #1c1c1c;
  border-radius: 14px;
  padding: 12px;
  margin-bottom: 12px;
}
.filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.select-wrap {
  flex: 1;
  min-width: 0;
}
.search-btn {
  flex-shrink: 0;
  height: 2.4rem;
  padding: 0 16px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  font-weight: 700;
  cursor: pointer;
}
.bingo-check {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0 0;
  color: #f0e6c8;
  font-weight: 600;
}
.loading-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1rem;
  color: #d8c48a;
}
.table {
  color: #f0e6c8;
  background: transparent;
}
.table thead th {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: #d8c48a;
  font-size: 0.78rem;
  font-weight: 700;
  background: transparent;
}
.table th,
.table td {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  color: #f0e6c8;
  background: transparent;
}
.betsliptable-row {
  cursor: pointer;
}
.betsliptable-row:active,
.betsliptable-row:hover {
  background: #2a2a2a;
}
.amount-cell {
  color: #f7d56a;
  font-weight: 700;
}
.date-cell {
  color: #c9c3b8;
  font-size: 0.78rem;
}
.gold-total {
  color: #f7d56a;
}
.bingo-total {
  color: #ff8a6a;
}
.capture-btn {
  width: 36px;
  height: 36px;
  margin: 8px 0 0 12px;
  border: 0;
  border-radius: 10px;
  background: #2a2a2a;
  color: #f7d56a;
  cursor: pointer;
}
.modal-cross {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  padding-top: 3px;
  margin-left: auto;
  color: white;
  cursor: pointer;
  margin-right: -9px;
  margin-top: -9px;
  background: rgb(228, 87, 87);
}
</style>
